document.addEventListener("DOMContentLoaded", () => {
    setDrawerControls();
})


function setDrawerControls() {
    const drawerContainer = document.getElementById('Details-menu-drawer-container');
    if (!drawerContainer) {
        throw new Error('"Details-menu-drawer-container" not found');
    }

    const closeButtons = drawerContainer.querySelectorAll('.menu-drawer__close-button');
    closeButtons.forEach((button) => {
        button.addEventListener('click', () => {
            const details = button.closest('details');
            const drawer = button.closest('.menu-drawer__submenu');

            if (details && drawer) {
                drawer.classList.add('closing');
                setTimeout(() => {
                    details.removeAttribute("open");
                    drawer.classList.remove('closing');
                }, 300);
            }
        });
    });
}